import { adminApi } from '~/api'
import { useQuery } from '@tanstack/react-query'

export const useCoursesQuery = () =>
  useQuery({
    queryKey: ['courses'],
    queryFn: async () => {
      const { data } = await adminApi.getCourses()
      return data.data
    }
  })
